<template>
<div class="chapter">
<div class="inner_page">
<div class="plm_hd">Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/DIS_authors">About the authors</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/DIS_preface">Preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/DIS_notetoreader">A note to the reader</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/DIS_seriesintro">Series introduction: the Contemporary Christian: the then and the now</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DIS_intro" title="Link target outside of Sample"><em class="italic">The Disciple</em> Introduction</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DIS_ch01" title="Link target outside of Sample">1 The listening ear</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DIS_ch02" title="Link target outside of Sample">2 Mind and emotions</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DIS_ch03" title="Link target outside of Sample">3 Guidance, vocation and ministry</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DIS_ch04" title="Link target outside of Sample">4 The first fruit of the Spirit</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DIS_conclusion" title="Link target outside of Sample">Conclusion: the now and the not yet</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/DIS_notes" title="Link target outside of Sample">Notes</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DIS_contents.vue?eac48614